import React, { Component, Fragment } from 'react'
import { channelList } from './channelList'
import { connect } from 'react-redux'
import { CMSPath, days, months, TVChannelsProgressBarRerenderTime } from '../../../config/constant'
import DefaultIcon from '../../images/icons/ico_channel.svg'
import { playOnTV } from '../../../components/tv-channels/channelController'
import { tvWidgetColors } from '../../JS/colorConfig'
import $ from 'jquery'
import { setCurrentTV } from '../../../action/tvChannelAction'
import { setGoHome } from '../../action/homeAction'
import {withTranslation} from "react-i18next";
import MiniLoader from '../../UI/MiniLoader'

class TVChannels extends Component {

    constructor(props) {
        super(props)
        this.state = {
            width: 1000,
            longestslots: 0,
            showCategoryList:false,
            showLanguageList:false,
            gettingChannelList: true,
            channelList:[],
            selectedCategory:"All categories",
            selectedLanguage:"All languages",
            allCategoryList: [],
            allLanguageList: [],
            categoryList: [],
            languageList:[],
            apiCalled: false,
            currentTime: new Date()
        }
    }

    setChannelListHandler = (chanNumList) => {

        console.log('set channel list handler called')

        if(!chanNumList){
            return;
        }

        let channels = [];

        chanNumList.map(el => {
            this.props.channelData.map(obj => {
                if(el === obj.channelNumber){
                    channels.push(obj);
                }
            })
        })

        // console.log("current channel list",channels);
        this.setState({channelList:channels});

        
    }


    getwidth = () => {
        let longestslots = 0, slot = 0
        if (this.props.channelData.length > 0) {
            this.props.channelData.map((itrator) => {
                itrator.schedules.map((itr) => {
                    if (itr.duration > 59) {
                        slot = slot + 2
                    } else {
                        slot = slot + 1
                    }
                })
                if (longestslots < slot) {
                    longestslots = slot
                }
                slot = 0
            })
        } else {
            longestslots = 2
        }
        if (longestslots < 2) {
            this.setState({ width: 2 * 163.2 + 60, longestslots: 2 });
        } else {
            this.setState({ width: longestslots * 163.2 + 60, longestslots: longestslots });
        }
    }

    getToken = () => {
        let token = null
        if (this.props.roomRemoteDetails.length > 0) {
            if (this.props.currentTv.remoteSessionToken) {
                token = this.props.currentTv.remoteSessionToken
            } else {
                console.log("No remoteSessionToken found.")
            }
        } else {
            //this.props.popupOpenClose(true, "No TVs to control are found.");
            console.log("No TVs to control are found");
        }
        console.log('getToken', token);
        return token
    }

    getTimeSlots = () => {
        let hours = 0, min = 0, dateforGuide = "", period = "AM"
        let dateAndTime = ""
        let scheduledate = new Date();
        dateforGuide = `<li class="date"><div>${days[scheduledate.getDay()]} ${months[scheduledate.getMonth()]} ${scheduledate.getDate()} ${scheduledate.getFullYear()}</div></li>`
        if (this.props.channelData.length > 0) {
            hours = scheduledate.getHours()
            period = hours <= 12 ? "AM" : "PM"
            min = scheduledate.getMinutes()
            dateAndTime += `${dateforGuide}<li>${hours > 12 ? hours - 12 : hours}:${min > 20 ? 30 : "00"}${period}</li>`
            console.log('this.state.longestslots',this.state.longestslots)
            for (let i = 0; i < this.state.longestslots-1; i++) {

                if (min < 29) {
                    min = 30
                    dateAndTime += `<li>${hours > 12 ? hours - 12 : hours}:${min}${period}</li>`
                } else {
                    if (hours < 24) { hours = hours + 1 } else { hours = 0 }
                    min = 0
                    dateAndTime += `<li>${hours > 12 ? hours - 12 : hours}:${"00"}${period}</li>`
                }
            }
            //return dateAndTime
            $('#timeList').html(dateAndTime)
        } else {
            $('#timeList').html(dateforGuide)
        }

    }

    clickChannel = (channel) => {
        let token = this.getToken();
        if(token) playOnTV(token, channel.channelNumber);
    }

    componentDidUpdate(prevProps,prevState){


        if(prevProps.channelData != this.props.channelData) {
            this.getwidth();
            this.setState({channelList: this.props.channelData,
                gettingChannelList: false,
                categoryList: Object.keys(this.props.categoryGrouping), languageList: Object.keys(this.props.languageGrouping),
                allCategoryList: this.props.categoryGrouping, allLanguageList: this.props.languageGrouping, apiCalled: true }
            )
        }

        if(prevState.selectedCategory !== this.state.selectedCategory || prevState.selectedLanguage !== this.state.selectedLanguage){
            if(this.state.selectedCategory !==  "All categories"  && this.state.selectedLanguage === "All languages"){
                let filteredChannelList = this.state.allCategoryList[this.state.selectedCategory]
                this.setChannelListHandler(filteredChannelList)
                this.setState({
                    languageList: this.setLanguageOptionsHandler(filteredChannelList)
                })
                
            }else if(this.state.selectedCategory === "All categories" && this.state.selectedLanguage !== "All languages"){
                let filteredChannelList = this.state.allLanguageList[this.state.selectedLanguage]
                this.setChannelListHandler(filteredChannelList)
                this.setState({
                    categoryList: this.setCategoryOptionsHandler(filteredChannelList)
                })
            }else if(this.state.selectedCategory !== "All categories" && this.state.selectedLanguage !== "All languages"){
                let categoryList = this.state.allCategoryList[this.state.selectedCategory];
                let languageList = this.state.allLanguageList[this.state.selectedLanguage];
                console.log('languageList',languageList)
                let arr = categoryList.filter(value => languageList.includes(value));
                this.setChannelListHandler(arr);
            }else{
                this.setState({channelList: this.props.channelData,
                     categoryList: Object.keys(this.state.allCategoryList),
                     languageList: Object.keys(this.state.allLanguageList)});
            }
        }

    }

    setLanguageOptionsHandler = (categoryChannels) => {
        let filtetredLanguageOptions = []
        let i,j

        for(i=0; i<categoryChannels.length; i++ ){
            for (let x in this.state.allLanguageList) {
                if(filtetredLanguageOptions.includes(x)){
                    // break;
                }
                if(this.state.allLanguageList[x].some( ch =>  categoryChannels[i].includes(ch))){
                    filtetredLanguageOptions.push(x);
                    //  break;
                }
            }
        }

        filtetredLanguageOptions = Array.from(new Set(filtetredLanguageOptions))

        console.log('filtetredLanguageOptions',filtetredLanguageOptions)
        return filtetredLanguageOptions;
    }

    setCategoryOptionsHandler = (languageChannels) => {
        let filtetredCategoryOptions = []
        let i,j

        for(i=0; i<languageChannels.length; i++ ){
            for (let x in this.state.allCategoryList) {
                if(filtetredCategoryOptions.includes(x)){
                    // console.log('filtetredCategoryOptions.includes(x) include',filtetredCategoryOptions.includes(x), x)
                    // break;
                }
                if(this.state.allCategoryList[x].some( ch =>  languageChannels[i].includes(ch))){
                    filtetredCategoryOptions.push(x);
                    // console.log('filtetredCategoryOptions.includes(x)',filtetredCategoryOptions.includes(x), x)
                    // break;
                }
            }
        }

        filtetredCategoryOptions = Array.from(new Set(filtetredCategoryOptions))

        console.log('filtetredCategoryOptions',filtetredCategoryOptions)
        return filtetredCategoryOptions;
    }

    filterLanguageOptions = (languageGroup, invalidChannelNumbers) => {
        let filterOptions = {}

        for(let key in languageGroup){
            if(languageGroup[key].length > 0){
                let chanelNums = []
                languageGroup[key].forEach(n => {
                    // if(!invalidChannelNumbers.includes(n)){
                        chanelNums.push(n)
                    // } 
                });
                filterOptions[key] = chanelNums
            }
        }
        console.log('languageOptions',filterOptions)
        return filterOptions;
    }

    filterCategoryOptions = (categoryGroup, invalidChannelNumbers) => {
        let filterOptions = {}

        for(let key in categoryGroup){
            if(categoryGroup[key].length > 0){
                let chanelNums = []
                categoryGroup[key].forEach(n => {
                    // if(!invalidChannelNumbers.includes(n)){
                        chanelNums.push(n)
                    // }
                });
                if(chanelNums.length > 0){
                    filterOptions[key] = chanelNums
                }
            }
        }

        console.log('categoryOptions',filterOptions)
        return filterOptions;
    }

    goBack = () => {
        console.log('this.props.roomRemoteDetails.length',this.props.roomRemoteDetails.length)
        if(this.props.roomRemoteDetails.length <= 1){
            this.props.setGoHome(true);
        } else {
            // window.history.back(-1);
            this.props.setCurrentTV({})
        }
    }

    componentDidMount() {
          // Set up an interval to update the current time
        this.timeInterval = setInterval(() => {
            const newTime = new Date();
            this.setState({ currentTime: newTime }); 
          }, TVChannelsProgressBarRerenderTime); 

        this.getwidth();
        // tvWidgetColors(this.props.menuColor)
        // this.setState({channelList:this.props.channelData});
        let channelsObj = this.props.channelData
        // let filteredCategoryList = this.filterCategoryOptions(this.props.categoryGrouping, channelsObj.invalidChannelNumbers)
        // let filteredLanguageList = this.filterLanguageOptions(this.props.languageGrouping, channelsObj.invalidChannelNumbers)

        this.setState({channelList: this.props.channelData,
                categoryList: Object.keys(this.props.categoryGrouping), languageList: Object.keys(this.props.languageGrouping),
                allCategoryList: this.props.categoryGrouping, allLanguageList: this.props.languageGrouping, apiCalled: true }
        )

        if(this.props.channelData.length > 0){
            this.setState({gettingChannelList: false})
        }
    }

      // Clear interval when the component unmounts to avoid memory leaks
        componentWillUnmount() {
            clearInterval(this.timeInterval);
        }

    render() {
        const { t } = this.props
        return (
            <Fragment>
                <header class="inner-pages w-footer subpages"
                style={{
                    backgroundColor: this.props.menuColor.assetBackgroundSelectorColor
                }}>
                    <a onClick={this.goBack} class="button-back"
                    //style="display: none;"
                    ></a>
                    <div class="heading align-center">

                        <div class="splash-brand">
                            <img src={`${CMSPath}${this.props.logo}`} />
                        </div>

                        {/* <p class="bold" style={{
                            color:this.props.menuColor.assetFontSelectorColor,
                            textShadow:"unset"
                        }}>{this.props.t('room_control.tv_control.guide_header')}</p> */}
                    </div>
                </header>
                <section id="tvControls" class="widgets padding-0 margin-0 container-bg channel-list">

                    <div class="widget-header widget-header-checkin">
                        { this.props.currentWidget.widgetHeaderImageUrl && 
                            <div class="widget-header-img">
                                <img src={`${CMSPath}${this.props.currentWidget.widgetHeaderImageUrl}`} alt={this.props.currentWidget.displayName} />
                            </div>
                        }
                        <div class="widget-header-title">{this.props.t('room_control.tv_control.guide_header')}</div>
                    </div>

                {
                    this.state.gettingChannelList ?
                        <MiniLoader />
                    :
                    <div class="widgets">
                        <div class="row padding-left-2 padding-right-2 multi-select">
                            <div class="tv-genre tile tile-container custom-select" style = {{
                                backgroundColor: this.props.menuColor.assetBackgroundSelectorColor
                            }}>
                                <div className="select-selected" onClick={() => this.setState(prev => ({showCategoryList:!prev.showCategoryList}))}
                                style = {{backgroundColor:"inherit"}}>
                                    {this.state.selectedCategory}
                                </div>
                                <div className={`select-items ${this.state.showCategoryList ? "" : "select-hide"}`}>
                                    <div onClick={() => {this.setState({selectedCategory:"All categories",showCategoryList:false})}}>{this.props.t('room_control.tv_control.all_catagory')}</div>
                                    {this.state.categoryList.map((el,index) => {
                                        return(<div key = {index} onClick={() => {this.setState({selectedCategory:el,showCategoryList:false})}}>{el}</div>)
                                    })}
                                </div>
                            </div>
                            <div class="tv-lang tile tile-container custom-select" style = {{
                                backgroundColor: this.props.menuColor.assetBackgroundSelectorColor
                            }}>
                                <div className="select-selected" onClick={() => this.setState(prev => ({showLanguageList: !prev.showLanguageList}))}
                                style = {{backgroundColor:"inherit"}}>
                                    {this.state.selectedLanguage}
                                </div>
                                <div className={`select-items ${this.state.showLanguageList ? "" : "select-hide"}`}>
                                    <div onClick={() => {this.setState({selectedLanguage:"All languages",showLanguageList:false})}}>{this.props.t('room_control.tv_control.all_lang')}</div>
                                    {this.state.languageList.map((el,index) => {
                                        return(<div key = {index} onClick={() => {this.setState({selectedLanguage:el,showLanguageList:false})}}>{el}</div>)
                                    })}
                                </div>
                            </div>
                        </div>
                        <div class="row padding-left-2 padding-right-2 ch-list">
                            <div class="ch-list-label">
                                <div class={`ch-list-time ${this.props.currentWidgetOb.widgetType === "EPG" ? "" : "no-epg"}`}>
                                    {this.props.currentWidgetOb.widgetType === "EPG" && <ul id="timeList" style={{ width: this.state.width }}>
                                        {this.getTimeSlots()}
                                        {/* <li class="date">June 11</li>
                                        <li>21:30</li>
                                        <li>22:00</li>
                                        <li>22:30</li>
                                        <li>23:00</li>
                                        <li>23:30</li>
                                        <li>00:00</li> */}
                                    </ul>}
                                    <div class="ch-list-menu" style={this.props.currentWidgetOb.widgetType === "EPG" ? { width: this.state.width } : {}}>
                                        {
                                            this.state.channelList.map((itrator) => {
                                                const currentTime = this.state.currentTime; 

                                                // Find the current program in the schedules
                                                const currentProgram = itrator.schedules.find((program) => {
                                                    const startTime = new Date(program.startTime);
                                                    const endTime = new Date(program.endTime);
                                                    return currentTime >= startTime && currentTime <= endTime;
                                                });

                                                  // Calculate progress percentage for the current program
                                                let progressPercentage = 0;
                                                if (currentProgram) {
                                                    const startTime = new Date(currentProgram.startTime);
                                                    const endTime = new Date(currentProgram.endTime);
                                                    progressPercentage = ((currentTime - startTime) / (endTime - startTime)) * 100;
                                                    progressPercentage = Math.min(progressPercentage, 100); 
                                                  }

                                                return (
                                                    <div class="ch-list-menu-row" onClick={() => this.clickChannel(itrator)} >

                                                         {/* Progress Bar Overlay */}
                                                         {currentProgram && (
                                                           <div className="progress-overlay"
                                                           style={{
                                                            width: `${progressPercentage}%`, // Update progress bar width based on the progress percentage
                                                           }}
                                                           ></div>
                                                            )}

                                                        <div class="ch-list-logo-container">
                                                            <div class="ch-list-logo"
                                                                style={{ background: `url('${itrator.iconUrl ? itrator.iconUrl : DefaultIcon}') center center no-repeat`, backgroundSize: "contain" }}
                                                            >
                                                                {
                                                                    // !itrator.iconUrl ?
                                                                    //     <img src={DefaultIcon} /> : ""
                                                                }

                                                            </div>
                                                        </div>
                                                        {
                                                            this.props.currentWidgetOb.widgetType === "EPG" ? 

                                                            itrator.schedules.length > 0 ?
                                                                itrator.schedules.map((itr) => {
                                                                    return (
                                                                        <div class={`ch-list-menu-item ${itr.duration > 59 ? "time-full-hour" : "time-half-hour"}`}>
                                                                            <div class="ch-list-desc">
                                                                                <span class="title">{itr.title}</span>
                                                                                <span class="desc">{itr.descLong}</span>
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                }) :
                                                                <div class="ch-list-menu-item time-full-hour">
                                                                    <div class="ch-list-desc">
                                                                        <span class="title">{itrator.channelName}</span>
                                                                        <span class="desc"></span>
                                                                    </div>
                                                                </div>

                                                            : 

                                                            <div class="ch-list-menu-item">
                                                            <div class="ch-list-desc">
                                                                <span class="title">{itrator.channelName}</span>
                                                                <span class="desc" style={{overflow: "initial",whiteSpace: "normal"}}></span>
                                                            </div>
                                                        { currentProgram ? (  
                                                                <div class="program-title">
                                                                    <span class="title">{currentProgram.title}</span>
                                                                </div>
                                                        ) : (
                                                                <div class="program-title no_program">
                                                                    <span class="desc">No current program</span>
                                                                </div>
                                                        )}

                                                        
                                                        </div>

                                                        }
                                                        {
                                                        }
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}
                </section>
            </Fragment>        )
    }
}

const mapStateToProps = state => {
    return {
        channelData: state.store.tvChannels.channelData,
        languageGrouping: state.store.tvChannels.languageGrouping ? state.store.tvChannels.languageGrouping : {},
        categoryGrouping: state.store.tvChannels.categoryGrouping ? state.store.tvChannels.categoryGrouping : {},
        roomRemoteDetails: state.store.tvChannels.roomRemoteDetails,
        currentWidget: state.store.sideNavBar.currentWidget,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        menuColor: state.store.home.MenuColor,
        currentTv: state.store.tvChannels.currentTv,
        currentWidgetOb: state.store.sideNavBar.currentWidget
    }
}
export default connect(
    mapStateToProps,
    {
        setCurrentTV,
        setGoHome
    }
)(withTranslation('translations')(TVChannels));